<script lang="ts" setup>
import { ref } from 'vue'
import PagePdCitySlugV1 from '@/components/pd/PagePdCitySlugV1/index.vue'
import PagePdCitySlugV2 from '@/components/pd/PagePdCitySlugV2/index.vue'
import { useThemeStore } from '@/stores/useThemeStore'

const { isV2 } = useThemeStore()

const showVersionTwo = ref(isV2)
</script>

<script lang="ts">
export default {
  name: 'PagePdCitySlugWrapper'
}
</script>

<template>
  <PagePdCitySlugV2
    v-if="showVersionTwo" />

  <PagePdCitySlugV1
    v-else />
</template>
